// 🔧 強制刷新工具 - 用於清除瀏覽器緩存
export const forceRefresh = () => {
  // 清除 localStorage 中的相關緩存
  const keysToRemove = [
    'checkplay_page_states',
    'checkplay_user_notes',
    'checkplay_video_cache',
    'checkplay_auth_state',
    'checkplay_guest_id'
  ];
  
  keysToRemove.forEach(key => {
    localStorage.removeItem(key);
  });
  
  // 清除 sessionStorage
  sessionStorage.clear();
  
  // 🔧 極端方案：清除所有 localStorage
  localStorage.clear();
  
  // 🔧 設置標記，避免重複觸發 WelcomeDialog
  localStorage.setItem('welcome_shown', '1');
  
  // 強制重新載入頁面，跳過緩存
  if (window.location.reload) {
    window.location.reload(true);
  } else {
    // 備用方案：使用 replace 跳轉到相同 URL
    window.location.href = window.location.href;
  }
};

// 🔧 檢查並清除可能的無限循環
export const checkAndClearInfiniteLoops = () => {
  // 清除可能導致循環的全局變量
  if (window.__checkplay_autoplay_flag) {
    window.__checkplay_autoplay_flag = false;
  }
  
  // 清除可能的定時器
  const highestTimeoutId = setTimeout(() => {}, 0);
  for (let i = 0; i < highestTimeoutId; i++) {
    clearTimeout(i);
  }
  
  const highestIntervalId = setInterval(() => {}, 0);
  for (let i = 0; i < highestIntervalId; i++) {
    clearInterval(i);
  }
  
  console.log('🧹 已清除可能的無限循環源');
};
